import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ByOrgItemBarChart from '../../graphics/byOrgItemBarChart';
import { formatVisiblePercent } from '../selfcare360/selfcare360Scales';

const { Text } = Typography;

const LeadershipByOrgItems = ({
    subtitle = "",
    singularSubtitle = "",
    chartData = [],
    redLight,
    yellowLight,
    serviceId,
    isFirstPage,
    customSummary
}) => {
    
    const renderItemSummary = () => {
        const formatWithAverage = (p) => `${p.name} (${formatVisiblePercent(p.average)})`;
        
        let top2;
        let bottom2;
        let bestText;
        let worstText;

        if (chartData.length > 4) {
            top2 = chartData.slice(0, 2);
            bottom2 = chartData.slice(-2);
            bestText = `${subtitle} que obtuvieron mejores resultados fueron`;
            worstText = `${subtitle} con los resultados más bajos fueron`;
        } else {
            top2 = chartData.slice(0, 1);
            bottom2 = chartData.slice(-1);
            bestText = `${singularSubtitle} que obtuvo mejor resultado fue`;
            worstText = `${singularSubtitle} con el resultado más bajo fue`;
        }
        const bestList = top2.map(formatWithAverage);
        const worstList = bottom2.map(formatWithAverage);

        return (
            <Text style={{ fontSize: '12px', textAlign: 'justify' }}>
                {bestText}{" "}
                <Text style={{fontSize: '12px'}} strong>{bestList.join(", ")}</Text>. <br />
                {worstText}{" "}
                <Text style={{fontSize: '12px'}} strong>{worstList.join(", ")}</Text>.
            </Text>
        );


    };
    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {isFirstPage && (
                <Card bordered style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                    {customSummary ? customSummary : renderItemSummary()}
                </Card>
            )}
            
            {/* Gráfico */}
            <div style={{ marginTop: 16 }}>
                <ByOrgItemBarChart
                    data={chartData}
                    redLight={redLight}
                    yellowLight={yellowLight}
                    serviceId={serviceId}
                />
            </div>
        </Space>
    );
};

export default LeadershipByOrgItems;
